var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-fullheight"},[_c('div',{staticClass:"hero-body is-paddingless"},[_c('div',{staticClass:"container vw-100"},[_c('Nuxt')],1)]),_vm._v(" "),_c('Loading',{ref:"loading"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }